import { Component, Input } from '@angular/core';

import { LucideAngularModule } from 'lucide-angular';

@Component({
  selector: 'app-empty-state',
  standalone: true,
  imports: [LucideAngularModule],
  template: `
    <div class="text-center py-16">
      <div class="w-20 h-20 bg-light-bg-secondary dark:bg-dark-surface-variant rounded-3xl flex items-center justify-center mx-auto mb-4">
        @if (icon) {
          <lucide-angular
            [img]="icon"
            class="w-10 h-10 text-light-text-tertiary dark:text-dark-text-tertiary"
          ></lucide-angular>
        } @else if (emoji) {
          <span class="text-3xl">{{ emoji }}</span>
        }
      </div>
      <h3 class="text-xl font-semibold text-light-text dark:text-dark-text mb-2">
        {{ title }}
      </h3>
      <p class="normal">{{ message }}</p>
      <ng-content></ng-content>
    </div>
  `,
})
export class EmptyStateComponent {
  @Input({ required: true }) title!: string;
  @Input({ required: true }) message!: string;
  @Input() icon?: any;
  @Input() emoji?: string;
}
